import { mainApi } from '../utils/api';

export type GetExpenseSetsInput = {
  orgId: number;
  projectId: number;
  datasetId: number;
};

export type GetExpenseSetByIdInput = {
  orgId: number;
  projectId: number;
  expenseSetId: number;
};

export type UpdateExpenseSetInput = {
  orgId: number;
  projectId: number;
  expenseSetId: number;
  data: {
    name: string;
    description?: string;
    dataset: number;
    predefined_expenses?: number[];
    userdefined_expenses?: number[];
  };
};

export type GetPreDefinedExpensesInput = {
  orgId: number;
};

export type GetPreDefinedExpenseByIdInput = {
  orgId: number;
  expenseId: number;
};

export type GetUserDefinedExpensesInput = {
  orgId: number;
  projectId: number;
};

export type GetUserDefinedExpenseByIdInput = {
  orgId: number;
  projectId: number;
  expenseId: number;
};

export type CreateUserDefinedExpenseInput = {
  orgId: number;
  projectId: number;
  data: {
    name: string;
    description?: string;
    formula: string;
    project: number;
    group: number;
  };
};

export type UpdateUserDefinedExpenseInput = {
  orgId: number;
  projectId: number;
  expenseId: number;
  data: {
    name?: string;
    description?: string;
    formula?: string;
    group?: number;
    project: number;
  };
};

export type DeleteUserDefinedExpenseInput = {
  orgId: number;
  projectId: number;
  expenseId: number;
};

export type GetExpenseFormulaVariablesInput = {
  orgId: number;
  projectId: number;
};

export type GetSharedUserDefinedExpensesInput = {
  orgId: number;
  modelId?: number;
  projectId: number;
};

export type GetReceivedUserDefinedExpensesInput = {
  orgId: number;
  modelId?: number;
  projectId: number;
};

const getPreDefinedExpenses = ({ orgId }: GetPreDefinedExpensesInput) =>
  mainApi.get(`organizations/${orgId}/predefined_expenses/`);

const getPreDefinedExpenseById = ({
  orgId,
  expenseId,
}: GetPreDefinedExpenseByIdInput) =>
  mainApi.get(`organizations/${orgId}/predefined_expenses/${expenseId}/`);

const getUserDefinedExpenses = ({
  orgId,
  projectId,
}: GetUserDefinedExpensesInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/userdefined_expenses/`
  );

const getSharedUserDefinedExpenses = ({
  orgId,
  projectId,
  modelId,
}: GetSharedUserDefinedExpensesInput) =>
  mainApi.get(
    modelId
      ? `organizations/${orgId}/projects/${projectId}/shared_userdefined_expenses/?model=${modelId}`
      : `organizations/${orgId}/models/${modelId}/shared_userdefined_expenses/`
  );

const getReceivedUserDefinedExpenses = ({
  orgId,
  projectId,
  modelId,
}: GetReceivedUserDefinedExpensesInput) =>
  mainApi.get(
    modelId
      ? `organizations/${orgId}/projects/${projectId}/received_userdefined_expenses/?model=${modelId}`
      : `organizations/${orgId}/projects/${projectId}/received_userdefined_expenses/`
  );

const getUserDefinedExpenseById = ({
  orgId,
  projectId,
  expenseId,
}: GetUserDefinedExpenseByIdInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/userdefined_expenses/${expenseId}/`
  );

const getExpenseFormulaVariables = ({
  orgId,
  projectId,
}: GetExpenseFormulaVariablesInput) =>
  mainApi.get(
    `organizations/${orgId}/projects/${projectId}/expense_formula_variables/`
  );

const updateUserDefinedExpense = ({
  orgId,
  projectId,
  expenseId,
  data,
}: UpdateUserDefinedExpenseInput) =>
  mainApi.patch(
    `organizations/${orgId}/projects/${projectId}/userdefined_expenses/${expenseId}/`,
    data
  );

const createUserDefinedExpense = ({
  orgId,
  projectId,
  data,
}: CreateUserDefinedExpenseInput) =>
  mainApi.post(
    `organizations/${orgId}/projects/${projectId}/userdefined_expenses/`,
    data
  );

const deleteUserDefinedExpense = ({
  orgId,
  projectId,
  expenseId,
}: DeleteUserDefinedExpenseInput) =>
  mainApi.delete(
    `organizations/${orgId}/projects/${projectId}/userdefined_expenses/${expenseId}/`
  );

export {
  createUserDefinedExpense,
  deleteUserDefinedExpense,
  getPreDefinedExpenseById,
  getPreDefinedExpenses,
  getUserDefinedExpenseById,
  getSharedUserDefinedExpenses,
  getUserDefinedExpenses,
  getExpenseFormulaVariables,
  updateUserDefinedExpense,
  getReceivedUserDefinedExpenses,
};
